import React, { MouseEventHandler, useCallback, useRef } from 'react'
import NavigationNavItem from './NavigationNavItem'
import Dropdown from 'components/Luxkit/Dropdown/Dropdown'
import DropdownContainer from 'components/Luxkit/Dropdown/DropdownContainer'
import ListItem from 'components/Luxkit/List/ListItem'
import StatusLabel from 'components/Luxkit/Label/StatusLabel'

interface Props {
  currentActiveNavItem?: App.NavItem
  isOpen: boolean
  navItem: App.NavItem
  onClose: MouseEventHandler<HTMLButtonElement | HTMLAnchorElement>
  onSubNavClick: (selection: string, position: number) => void
  onToggle: (navItem: App.NavItem) => void
  position: number;
}

function NavigationNavDropdownItem(props: Props) {
  const {
    currentActiveNavItem,
    isOpen,
    navItem,
    onClose,
    onSubNavClick,
    onToggle,
    position,
  } = props

  const navItemRef = useRef<HTMLButtonElement>(null)

  const handleToggle = useCallback(() => {
    onToggle(navItem)
  }, [navItem, onToggle])

  const handleSubNavClick = useCallback((e: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement, MouseEvent>, subNavPosition: number) => {
    onSubNavClick(e.currentTarget.id, position + subNavPosition)
    // after use clicks and navigates, design wants our 'active' indicator, not our focus state
    e.currentTarget.blur()
  }, [onSubNavClick, position])

  return <>
    <NavigationNavItem
      ref={navItemRef}
      navItem={navItem}
      onClick={handleToggle}
      open={isOpen}
      active={navItem === currentActiveNavItem}
      position={position}
    />
    <Dropdown
      triggerRef={navItemRef}
      open={isOpen && navItemRef.current?.style.display !== 'none'}
      onClose={onClose}
    >
      <DropdownContainer fit="dropdown-items">
        {navItem.items?.map((item, index) => (
          <ListItem
            size="small"
            key={item.id}
            id={item.id}
            aria-label={`Select ${item.text}`}
            onClick={(e) => handleSubNavClick(e, index)}
            to={item.to}
            href={item.href}
            title={item.text}
            className={item.linkClass}
            endIcon={item.newLabel && <StatusLabel variant="confirmation">NEW</StatusLabel>}
            selected={item === currentActiveNavItem}
          />
        ))}
      </DropdownContainer>
    </Dropdown>
  </>
}

export default NavigationNavDropdownItem
